export default __webpack_public_path__ + "static/media/loha-web.bf3504d5.jpg";